<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
      closeable
      close-icon-position="top-right"
      :close-on-click-overlay="false"
  >
    <div class="modal-container">
      <div class="modal-title">更新代销者信息</div>
      <div class="modal-tip">
        注意：基本身份信息不可修改，如需变更请联系福彩中心。
      </div>
      <van-form @submit="onSubmit">
        <!--        姓名-->
        <van-field
            v-model.trim="form.agentName"
            name="agentName"
            label="姓名"
            placeholder="请输入姓名"
            disabled
        />
        <!--        身份证号-->
        <van-field
            v-model.trim="form.idCard"
            name="idCard"
            label="联系身份证号"
            placeholder="请输入身份证号"
            disabled
        />
        <!--        手机号码-->
        <van-field
            v-model.trim="form.contact"
            name="bankUserPhone"
            label="手机号码"
            placeholder="请输入手机号码"
            :rules="[
                { required: true, message: '请输入手机号码' },
                { message:'手机号码格式错误', pattern:new RegExp(/^(?:(?:\+|00)86)?1[1-9]\d{9}$/)}]"
        />
        <div class="form-group">
<!--          <label class="form-label">验证码</label>-->
          <div class="verification-group">
            <input type="number" class="form-input verification-input" v-model.trim="code" placeholder="请输入验证码" maxlength="6" />
            <button class="verification-button" :class="disable?'disabled':''">
              <span v-show="disable">{{count}}s后重新获取</span>
              <span v-show="!disable" @click="getPhoneCode">获取验证码</span>
            </button>
          </div>
        </div>
        <!--        备用联系电话-->
<!--        <van-field-->
<!--            v-model="form.backPhone"-->
<!--            name="backPhone"-->
<!--            label="备用联系电话"-->
<!--            placeholder="请输入备用联系电话(选填)"-->
<!--        />-->
        <!--        电子邮箱-->
<!--        <van-field-->
<!--            v-model="form.email"-->
<!--            name="email"-->
<!--            label="电子邮箱"-->
<!--            placeholder="请输入电子邮箱(选填)"-->
<!--        />-->
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="cancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit">保存</van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<script>
import {blurRule} from "@/untils/common";
import {sendSmsCode} from "@/lib/request";

export default {
  name: 'updateUserInfo',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    branchId:{
      type:String,
      default: ''
    },
    agentInfo:{
      type:Object,
      default: {}
    }
  },
  data() {
    return {
      showPopup: this.value,
      form: {
        // agentName: '',
        // contact: '',
        // idCard: '',
        // backPhone: '',
        // "code":"",
        // "branchId":"",
        // "agentName":"",
        // "contact":"",
        // "idCard":""
      },

      code:'',
      disable:false,
      count:0,
      timer: null,
    }
  },
  watch: {
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },

    agentInfo(newVal) {
      if (newVal) {
        this.processData(newVal);
        // this.stateName = newVal.businessStatus;
      }
    }
  },
  created() {
  },
  methods: {

    processData(item){
      this.form = item;
    },
    getPhoneCode(){
      let self = this;
      if(self.form.contact===''){
        self.$toast('请输入手机号码');
        return false;
      }else if (!blurRule(self.form.contact, {name: 'phone'})) {
        return false;
      }else{
        sendSmsCode({ phonenumber: this.form.contact }).then(res => {
          if (res.data.code === 200) {
            self.disable = true;
            const TIME_COUNT = 60;
            if (!self.timer) {
              self.count = TIME_COUNT;
              self.timer = setInterval(() => {
                if (self.count > 0 && self.count <= TIME_COUNT) {
                  self.count--;
                } else {
                  clearInterval(self.timer);
                  self.timer = null;
                  self.disable = false;
                }
              }, 1000)
            }
            this.$toast.success(res.data.msg)
          } else {
            // this.timeCount = 0;
            this.$toast.fail(res.data.msg)
          }
        }).catch(() => {
          // this.timeCount = 0;
        });
      }
    },
    onSubmit() {
      let self = this;
      if(self.form.contact===''){
        self.$toast('请输入手机号码');
        return false;
      }else if (!blurRule(self.form.contact, {name: 'phone'})) {
        return false;
      }else if(self.code===''){
        self.$toast('请输入短信验证码');
        return false;
      }
      this.form.code = this.code;
      this.form.branchId = this.branchId;
      self.$emit('submit', { ...self.form });
    },
    cancel() {
      this.showPopup = false
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-tip{
  margin-bottom: 20px;
  color: var(--text-secondary);
  font-size: 26px;
  background-color: #f8f9fd;
  padding: 12px;
  border-radius: var(--radius-sm);
}

.form-group {
  margin-bottom: 0;
  background: white;
  padding:0 0 10px;
}

.form-label {
  display: block;
  margin-bottom: 20px;
  font-size: 28px;
  color: var(--text-secondary);

}

.form-input {
  width: 100%;
  padding:24px 20px 20px 30px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 28px;
  background-color: #f9f9f9;
}

.verification-group {
  display: flex;
  gap: 12px;
}

.verification-input {
  flex: 1;
}

.verification-button {
  width: 220px;
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  border-radius: var(--radius-sm);
  font-size: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.verification-button:active {
  background-color: #fff8f8;
}

.verification-button.disabled {
  border-color: var(--text-light);
  color: var(--text-light);
  cursor: not-allowed;
}
</style>
